import { Footer, GlobalFooter, GlobalHeader } from '../components'
import { Card, Col, Row } from 'antd'

import DownloadStyle from '../../../styles/DownloadMobileApp.module.css'

const DownloadMobileApp = () => {
  return (
    <div className="container">
      <GlobalHeader />
      <>
        <Row className={`${DownloadStyle["download-app-screen"]} page-text-margin`}>
          {/* Desktop */}
          <Col
            lg={{ span: 12 }}
            md={{ span: 0 }}
            sm={{ span: 0 }}
            style={{ maxWidth: 610 }}
            xl={{ span: 14 }}
            xs={{ span: 0 }}
          >
            <header className={`empty-header-hero`}>
              <Row>
                <h2 className={`${DownloadStyle["download-page"]}`}>
                  Download the CURE App
                </h2>
              </Row>
              <hr className={`${DownloadStyle["underline-title"]}`} />
            </header>
            <div className={`${DownloadStyle["download-app-container"]}`}>
              <Row>
                <Card className={`${DownloadStyle["register-card"]} ${DownloadStyle["center-content"]}`}>
                  <Row>
                    <Col lg={{ span: 12 }} xs={{ span: 12 }}>
                      <p>
                        A great resource anywhere, anytime, right in the palm of your hand! Here are some tools available at your fingertips:
                      </p>

                      <div style={{ marginLeft: '30px' }}>
                        <ul className={`${DownloadStyle["list-features"]}`}>
                          <li>View ID Cards</li>
                          <li>Make a payment</li>
                          <li>Check upcoming payment dates</li>
                          <li>Connect to Roadside Assistance</li>
                          <li>Report a claim</li>
                          <li>Request policy changes</li>
                          <li>Contact customer service</li>
                        </ul>
                      </div>
                      <p className={`${DownloadStyle["download-text"]}`}>
                        What are you waiting for? Download now!
                      </p>

                      <div className={`${DownloadStyle["store-logo"]}`}>
                        <a href='https://apps.apple.com/us/app/cure-auto-insurance/id1640122356' target='_blank'>
                          <img alt="logo" width={150} className="logo" src="https://www.cure.com/images/store_appstore.png" />
                        </a>
                        <a href='https://play.google.com/store/apps/details?id=com.vazkordev.CureApp&hl=en-US' target='_blank'>
                          <img alt="logo" width={150} className="logo" src="https://www.cure.com/images/store_googleplay.png" />
                        </a>
                      </div>
                    </Col>
                    <Col lg={{ span: 10, offset: 1 }} sm={{ span: 5 }} xs={{ span: 12 }}>
                      <a>
                        <img alt="logo" width={425} className="logo" src="https://www.cure.com/images/phone_stacked.png" />
                      </a>
                    </Col>
                  </Row>
                </Card>
              </Row>
            </div>
          </Col>

          {/* Mobile */}
          <Col
            lg={{ span: 0 }}
            md={{ span: 24 }}
            sm={{ span: 24 }}
            xl={{ span: 0 }}
            xs={{ span: 24 }}
          >
            <header className={`empty-header-hero`} style={{ marginTop: 0 }}>
              <h1 className={`${DownloadStyle["download-page-mobile"]}`} >
                Download Our App
              </h1>
            </header>
            <div className={`${DownloadStyle["center-phone-stacked"]}`}>
              <a>
                <img alt="logo" width={200} className="logo" src="https://www.cure.com/images/phone_stacked.png" />
              </a>
            </div>
            <div>
              <div>
                <p className={`${DownloadStyle["summary-mobile"]}`}>
                  A great resource anywhere, anytime, right in the palm of your hand! Here are some tools available at your fingertips:
                </p>
                <div className={`${DownloadStyle["summary-mobile"]}`}>
                  <ul className={`${DownloadStyle["list-features-mobile"]}`}>
                    <li>View ID Cards</li>
                    <li>Make a payment</li>
                    <li>Check upcoming payment dates</li>
                    <li>Connect to Roadside Assistance</li>
                    <li>Report a claim</li>
                    <li>Request policy changes</li>
                    <li>Contact customer service</li>
                  </ul>
                </div>
              </div>
              <hr className={`${DownloadStyle["underline-title-mobile"]}`} />
            </div>
            <p className={`${DownloadStyle["download-text-mobile"]}`}>
              What are you waiting for? <br />
              Download now!
            </p>

            <div className={`${DownloadStyle["store-logo-mobile"]}`}>
              <a href='https://apps.apple.com/us/app/cure-auto-insurance/id1640122356' target='_blank'>
                <img alt="logo" width={150} className="logo" src="https://www.cure.com/images/store_appstore.png" />
              </a>
              <a href='https://play.google.com/store/apps/details?id=com.vazkordev.CureApp&hl=en-US' target='_blank'>
                <img alt="logo" width={150} className="logo" src="https://www.cure.com/images/store_googleplay.png" />
              </a>
            </div>
          </Col>
        </Row>
        <div className={`${DownloadStyle["display-footer-mobile"]}`}>
          <Footer />
        </div>
      </>
      <GlobalFooter />
    </div>
  )
}

DownloadMobileApp.propTypes = {}

export default DownloadMobileApp